<template>
  <el-steps direction="vertical" :active="stepsActive" finish-status="success">
    <el-step
      :title="getTitle('Create')"
      :status="getStatus('Create')"
      :icon="getIcon('Create')"
    >
      <div
        slot="description"
        class="fm-flex fm-margin-bottom-10"
        style="font-size: 14px"
      >
        <UserAvatar :userInfo="orderInfo.creator"></UserAvatar>
        <div v-fmtype="'text'">
          {{ orderInfo.creator.name }}<br />
          <span v-show="isDisplayTime" v-fmtype="'info'">
            {{ orderInfo.createTime }}</span
          >
        </div>
      </div>
    </el-step>
    <el-step
      :title="getTitle('Submit')"
      :status="getStatus('Submit')"
      :icon="getIcon('Submit')"
    >
      <div
        slot="description"
        class="fm-margin-bottom-10"
        style="font-size: 14px"
      >
        <div class="fm-flex" v-if="stepsActive > 1">
          <UserAvatar :userInfo="orderInfo.creator"></UserAvatar>
          <div v-fmtype="'text'">
            {{ orderInfo.submitUser.name }}<br />
            <span v-show="isDisplayTime" v-fmtype="'info'">
              {{ orderInfo.submitTime }}</span
            >
          </div>
        </div>
        <div v-else>未提交审批</div>
      </div>
    </el-step>
    <el-step :title="getTitle('Handle')" :status="getStatus('Handle')">
      <i slot="icon" :class="getIcon('Handle')"></i>
      <div
        slot="description"
        class="fm-margin-bottom-10"
        style="font-size: 14px"
      >
        <div class="fm-flex" v-if="stepsActive > 2">
          <UserAvatar :userInfo="orderInfo.handleUser"></UserAvatar>
          <div v-fmtype="'text'">
            {{ orderInfo.handleUser.name }}<br />
            {{ "审批意见：" + orderInfo.handleMessage }}<br />
            <span v-show="isDisplayTime" v-fmtype="'info'">
              {{ orderInfo.handleTime }}</span
            >
          </div>
        </div>
        <div v-else-if="stepsActive == 2">审批中...</div>
        <div v-else>未提交审批</div>
      </div>
    </el-step>
  </el-steps>
</template>

<script>
export default {
  name: "Fmerpv2WebOrderStep",
  props: {
    orderInfo: {
      type: Object,
      default: null,
    },
    displayTime: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    stepsActive() {
      let res = 0;
      if (this.orderInfo.createTime) {
        res = 1;
      }
      if (this.orderInfo.submitTime) {
        res = 2;
      }
      if (this.orderInfo.handleTime) {
        res = 3;
      }
      return res;
    },
    isDisplayTime() {
      if (this.orderInfo.orderApprovalStatusEnum.Name == "Approval") {
        return this.displayTime;
      } else {
        return true;
      }
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    getIcon(type) {
      if (type == "Create") {
        return "el-icon-circle-check";
      } else if (type == "Submit") {
        return this.stepsActive > 1
          ? "el-icon-circle-check"
          : "el-icon-remove-outline";
      } else if (type == "Handle") {
        if (this.stepsActive > 2) {
          return this.orderInfo.orderApprovalStatusEnum.Name == "Approval"
            ? "el-icon-circle-check"
            : "el-icon-circle-close";
        } else {
          return "el-icon-remove-outline";
        }
      }
    },
    getTitle(type) {
      if (type == "Create") {
        return "制单";
      } else if (type == "Submit") {
        return "提交审批";
      } else if (type == "Handle") {
        if (this.stepsActive > 2) {
          return this.orderInfo.orderApprovalStatusEnum.Name == "Approval"
            ? "审批结果：审批通过"
            : "审批结果：审批拒绝";
        } else if (this.stepsActive == 2) {
          return "审批中...";
        } else {
          return "审批结果";
        }
      }
    },
    getStatus(type) {
      if (type == "Create") {
        return "finish";
      } else if (type == "Submit") {
        return this.stepsActive > 1 ? "finish" : "wait";
      } else if (type == "Handle") {
        if (this.stepsActive > 2) {
          return this.orderInfo.orderApprovalStatusEnum.Name == "Approval"
            ? "success"
            : "error";
        } else if (this.stepsActive == 2) {
          return "process";
        } else {
          return "wait";
        }
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/OrderStep.vue